import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  constructor(private readonly http: HttpClient) {}

  getStates = () => {
    return this.http.get(`${environment.api.baseAddress}/api/states/all`);
  };
}
